import moonlitNightBeginning from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightBeginning.mp3";
import moonlitNightBeginningArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightBeginningArranged.mp3";
import moonlitNightFirstDevelopmentArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightFirstDevelopmentArranged.mp3";
import moonlitNightClassicalSnippet1Arranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightClassicalSnippet1Arranged.mp3";
import moonlitNightClassicalSnippet2Arranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightClassicalSnippet2Arranged.mp3";
import moonlitNightClassicalSnippet3Arranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightClassicalSnippet3Arranged.mp3";
import trepakDance from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\trepakDance.mp3";
import symphony5Waltz from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\symphony5Waltz.mp3";
import AudioSection, { AlternateAudioPlayer } from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audioSection\\index.tsx";
import moonlitNightMoreModern1Arranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightMoreModern1Arranged.mp3";
import moonlitNightMoreModern2Arranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightMoreModern2Arranged.mp3";
import moonlitNightMoreModern3Arranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\moonlitNightMoreModern3Arranged.mp3";
import korobeinikiBeginningArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\korobeinikiBeginningArranged.mp3";
import korobeinikiBeginning from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\korobeinikiBeginning.mp3";
import indianViolin from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\indianViolin.mp3";
import romanianViolin from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\romanianViolin.mp3";
import hurdyGurdy from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\hurdyGurdy.mp3";
import korobeinikiHandinHandMoment from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\korobeinikiHandinHandMoment.mp3";
import korobeinikiEndingArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\korobeinikiEndingArranged.mp3";
import endingOfSecondBeginningOfThird from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\endingOfSecondBeginningOfThird.mp3";
import secondMovementBeginning from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementBeginning.mp3";
import secondMovementBeginningArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementBeginningArranged.mp3";
import secondMovementTransformed from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementTransformed.mp3";
import secondMovementTransformedArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementTransformedArranged.mp3";
import secondMovementFolkExample from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementFolkExample.mp3";
import secondMovementLastSnippet1 from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementLastSnippet1.mp3";
import secondMovementLastSnippet2 from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementLastSnippet2.mp3";
import secondMovementLastSnippet3 from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\secondMovementLastSnippet3.mp3";
import lastPartOfArrangement from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\lastPartOfArrangement.mp3";
import middleOfLastMovement from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\middleOfLastMovement.mp3";
import beginningOfLastMovement from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\beginningOfLastMovement.mp3";
import irishBeginningArranged from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishBeginningArranged.mp3";
import irishTap from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishTap.mp3";
import quebecTap from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\quebecTap.mp3";
import irishEtherealPart from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishEtherealPart.mp3";
import irishOpenStringPlucked from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishOpenStringPlucked.mp3";
import irishOpenStringPadEnding from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishOpenStringPadEnding.mp3";
import irishCounterMelody from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishCounterMelody.mp3";
import irishWaltzOfFlower from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishWaltzOfFlower.mp3";
import irishConcertoThirdMovement from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\irishConcertoThirdMovement.mp3";
import everythingTogether from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\everythingTogether.mp3";
import glinkaStagnation from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\result\\audio\\snippets\\glinkaStagnation.mp3";
import * as React from 'react';
export default {
  moonlitNightBeginning,
  moonlitNightBeginningArranged,
  moonlitNightFirstDevelopmentArranged,
  moonlitNightClassicalSnippet1Arranged,
  moonlitNightClassicalSnippet2Arranged,
  moonlitNightClassicalSnippet3Arranged,
  trepakDance,
  symphony5Waltz,
  AudioSection,
  AlternateAudioPlayer,
  moonlitNightMoreModern1Arranged,
  moonlitNightMoreModern2Arranged,
  moonlitNightMoreModern3Arranged,
  korobeinikiBeginningArranged,
  korobeinikiBeginning,
  indianViolin,
  romanianViolin,
  hurdyGurdy,
  korobeinikiHandinHandMoment,
  korobeinikiEndingArranged,
  endingOfSecondBeginningOfThird,
  secondMovementBeginning,
  secondMovementBeginningArranged,
  secondMovementTransformed,
  secondMovementTransformedArranged,
  secondMovementFolkExample,
  secondMovementLastSnippet1,
  secondMovementLastSnippet2,
  secondMovementLastSnippet3,
  lastPartOfArrangement,
  middleOfLastMovement,
  beginningOfLastMovement,
  irishBeginningArranged,
  irishTap,
  quebecTap,
  irishEtherealPart,
  irishOpenStringPlucked,
  irishOpenStringPadEnding,
  irishCounterMelody,
  irishWaltzOfFlower,
  irishConcertoThirdMovement,
  everythingTogether,
  glinkaStagnation,
  React
};